// extracted by mini-css-extract-plugin
export default {"avatar":"style-module--avatar--5MtTw","title":"style-module--title--tYQtT","imgCard":"style-module--imgCard--Q8Xz7"};